import sendRequest from "../../../helpers/requestHelper";
import config from "../../../config";
import eventBus from "../../../event-bus/eventBus";

const getCalculation = {
    namespaced: true,
    state: {
        calculationData: [],
        dataGetCalculationFetching: false,
    },
    mutations: {
        GET_CALCULATION_SUCCESS(state, response) {
            state.calculationData = response.data;
            eventBus.$emit("getCalculationSuccess", response["data"]);
            state.dataGetCalculationFetching = false;
        },
        GET_CALCULATION_FAILURE(state, error) {
            console.log(error);
            state.dataGetCalculationFetching = false;
            eventBus.$emit("getCalculationFailure");
        }
    },
    actions: {
        getCalculationRequest: function({ dispatch, state }, payload) {
            state.dataGetCalculationFetching = true;
            let promise = sendRequest("get", config.baseURLApi + "/calculations/" + payload.creds.id, {}, {}, true, payload.creds);
            promise.then(function(result) {
                if(result[0] === "success") {
                    dispatch("successGetCalculation", result[1]);
                } else {
                    dispatch("failureGetCalculation", result[1]);
                }
            })
        },
        successGetCalculation: function({ commit }, response) {
            commit("GET_CALCULATION_SUCCESS", response);
        },
        failureGetCalculation: function({ commit }, error) {
            commit("GET_CALCULATION_FAILURE", error);
        }
    }
}

export default getCalculation;